import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import EdpiesLogo from '@/components/EdpiesLogo';

// PersonalizedHub now redirects to the 16-week LearningPathGrid
const PersonalizedHub = ({ progress, updateProgress }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the new 16-week learning path grid
    navigate('/learning-path', { replace: true });
  }, [navigate]);

  // Show loading state while redirecting
  return (
    <div 
      data-testid="personalized-hub"
      className="min-h-screen bg-gradient-to-br from-slate-50 via-indigo-50/30 to-white flex items-center justify-center"
    >
      <div className="text-center">
        <div className="mx-auto mb-4">
          <EdpiesLogo size="xl" />
        </div>
        <p className="text-slate-500">Loading your learning path...</p>
      </div>
    </div>
  );
};

export default PersonalizedHub;
